// @flow strict

import * as React from 'react';

import { ProductIcon } from '@gandi/cart';
import type { ApplicationSummary } from '@gandi/redux-resource-simplehosting';
import { useTranslator } from '@gandi/translate';
import { Base } from '@gandi/ui';

import styles from './OffersIntro.scss';

type Props = {
  application?: ApplicationSummary,
};

export default function OffersIntro({
  application,
}: Props): React.MixedElement {
  const { __ } = useTranslator();

  return (
    <Base className={styles.root} flex flexAlignItemsCenter flexJustifyCenter>
      <ProductIcon className={styles.icon} type="paas" />
      <Base margin="none" tagName="h2">
        {application
          ? __(
              'First, choose the best plan for your Hosting with %(appName)s',
              { appName: application?.name_label },
            )
          : __('First, choose the best plan for your Web Hosting')}
      </Base>
    </Base>
  );
}
